// extracted by mini-css-extract-plugin
export default {"cls1":"mentions_milestone_ping-cls1_jtI","cls2":"mentions_milestone_ping-cls2_xM_ mentions_milestone_ping-cls1_jtI"};